import React, { useEffect, useState, useMemo } from "react";
import NuevaFacturacion from "./NuevaFacturacion";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable from "material-react-table";
import {
  Container,
  Typography,
  Button,
  Paper,
  Stack,
  Divider,
  IconButton,
  Tooltip
} from "@mui/material";

import ReceiptIcon from "@mui/icons-material/Receipt"; 
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import moment from "moment";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


import Navbar from "../Navbar";
import * as api from "./api";
import { logEventos } from "../../services/services";
import Header from "../Header";
import EstadoChip from "../remitos/components/EstadoChip";
import DialogNuevaFactContainer from "./components/DialogNuevaFactContainer";
import DialogNuevaFactEnvasadoContainer from "./components/DialogNuevaFactEnvasadoContainer";

const BRAND = {
  main: "#2471A3",
  dark: "#1B4F72",
  light: "#EAEFF1",
  contrast: "#ffffff",
};

function FacturacionRemitosList() {
  //Todos los pedidos/remitos a facturar.
  const [pedidos, setPedidos] = useState();
  const [remitoSeleccionado, setRemitoSeleccionado]=useState(null);
  const [tabla, setTabla] = useState(true);
  const [showNuevaFactura, setShowNuevaFactura] = useState(false);
  const [showDialogNuevaFact, setShowDialogNuevaFact] = useState();
  const [showDialogEnvasado, setShowDialogEnvasado] = useState(false);
  const [envasadoRow, setEnvasadoRow] = useState(null);
  const [showAlert, setShowAlert]=useState();


  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    showColumnFilters: false,
    pagination: {
      pageSize: 10,
      pageIndex: 0,
    },
    sorting: [
      {
        id: "fecha",
        desc: true,
      },
    ],
  };

  useEffect(() => {
    api.getPedidos(setPedidos);
  }, []);

  const closeNuevaFacturacion = () => {
    setTabla(true);
    setShowNuevaFactura(false);
    api.getPedidos();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "nro_remito",
        header: "N°",
        size: 100,
        enableColumnFilter: true,
      },
      {
        id: "fecha",
        header: "Fecha",
        size: 90,
        enableColumnFilter: true,
        accessorFn: (row) => row.fecha_remito || row.fecha_real_entrega,
        Cell: ({ cell }) =>
          cell.getValue() ? moment(cell.getValue()).format("DD-MM-YYYY") : "",
        sortingFn: "datetime",
      },
      {
        accessorKey: "empresa",
        header: "Empresa",
        size: 100,
      },
      {
        accessorKey: "suc_atiende",
        header: "Suc. Remite",
        size: 120,
      },
      {
        accessorKey: "cliente",
        header: "Cliente",
        size: 260,
      },
      {
        accessorKey: "estado",
        header: "Estado",
        size: 80,
        Cell: ({ row }) => <EstadoChip estado={row.original.estado} />,
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar en todos los campos...",
    size: "small",
    sx: { minWidth: 280 },
    variant: "outlined",
  };

  const tableHeadCellProps = {
    sx: {
      bgcolor: "#f8fafc",
      fontWeight: 700,
      color: "text.primary",
      borderBottom: "1px solid",
      borderColor: "divider",
    },
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: false,
    expand: <ExpandMoreIcon />,
  };

  useEffect(() => {
    logEventos(
      "acceso al menú Facturacion Remitos",
      "Granel",
      "Facturacion Remitos",
      localStorage.getItem("user")
    );
  }, []);

  return (
    <div>
      <Navbar />
      {tabla && pedidos && columns ? (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 4 }}>
          <Header
            title={"Facturación de remitos"}
            BRAND={BRAND}
            chipIcon={
              <LocalShippingOutlinedIcon sx={{ color: "inherit !important" }} />
            }
            label={`${pedidos?.length || 0} remitos pendientes`}
          />
          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              border: "1px solid",
              borderColor: "divider",
              "& .MuiPaper-root": { boxShadow: "none" },
            }}
          >
            <MaterialReactTable
              enableFacetedValues
              enableRowActions={true}
              positionActionsColumn={"last"}
              displayColumnDefOptions={{
                "mrt-row-actions": {
                  header: "Acciones",
                  size: 20, 
                  grow: false,
                },
              }}              
              renderRowActions={({ row }) => (
                <Tooltip title="Facturar">
                  <IconButton
                    color="primary"
                    onClick={() => {
                      if (row.original.origen_envasado === "envasado") {
                        if(!row.original.facturar_a) {
                          setShowAlert(true) 
                          return
                        }
                        setEnvasadoRow(row.original);
                        setShowDialogEnvasado(true);
                      } else {
                        setShowDialogNuevaFact(true);
                        setRemitoSeleccionado(row.original);
                      }
                    }}
                  >
                    <ReceiptIcon />
                  </IconButton>
                </Tooltip>
              )}
              columns={columns}
              data={pedidos}
              localization={customLocalization}
              enablePinning={false}
              enableDensityToggle={false}
              enableExpandAll={false}
              initialState={initialState}
              muiTableHeadCellProps={tableHeadCellProps}
              muiTableBodyCellProps={{ sx: { borderColor: "divider" } }}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              renderTopToolbarCustomActions={() => (
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  sx={{ flexWrap: "wrap", gap: 1, py: 0.5, pl: 0.5 }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={() => {
                      setShowNuevaFactura(true);
                      setTabla(false);
                    }}
                    sx={{
                      borderRadius: 2,
                      px: 2.5,
                      fontWeight: 600,
                      boxShadow: "0 4px 12px rgba(36,113,163,0.35)",
                    }}
                  >
                    Facturar
                  </Button>
                  <Divider orientation="vertical" flexItem />
                  <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    color="text.secondary"
                  >
                    Remitos A Facturar
                  </Typography>
                </Stack>
              )}
            />
          </Paper>
        </Container>
      ) : null}
      {showNuevaFactura && <NuevaFacturacion close={closeNuevaFacturacion} />}
      {showDialogNuevaFact &&
        <DialogNuevaFactContainer
          open={showDialogNuevaFact}
          setOpen={setShowDialogNuevaFact}
          remitoSeleccionado={remitoSeleccionado}
        />}
      {showDialogEnvasado && envasadoRow && (
        <DialogNuevaFactEnvasadoContainer
          open={showDialogEnvasado}
          setOpen={setShowDialogEnvasado}
          row={envasadoRow}
        />
      )}
      {showAlert && (
        <Snackbar open={showAlert} autoHideDuration={6000} onClose={()=>setShowAlert(false)}>
          <Alert
            onClose={()=>setShowAlert(false)}
            severity="error"
            variant="filled"
            sx={{ width: '100%' }}
          >
            Este remito no puede facturarse porque faltan datos de facturación. Por favor, complete el campo "Facturar A" en el perfil del cliente.
          </Alert>
        </Snackbar>
      )}
    </div>
  );
}

export default FacturacionRemitosList;
